import { Component, inject, signal, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MenuStore, MenuItem, MenuKey } from '@brighthub/shell/data-access-menu';
import { RippleModule } from 'primeng/ripple';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

@Component({
  selector: 'bhub-menu',
  imports: [CommonModule, RouterLink,RippleModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('closed <=> open', animate('200ms ease-in-out'))
    ])
  ]
})
export class MenuComponent {
  private _menuStore = inject(MenuStore);
  readonly _router = inject(Router);

  menuItems: Signal<MenuItem[]> = this._menuStore.menu(MenuKey.MAIN);
  openSubmenus = signal<Record<string, boolean>>({});


  isActive(route: string | undefined): boolean {
    if (route) return this._router.url.startsWith(route);
    return false;
  }

  toggle(id: string) {
    this.openSubmenus.update((state) => ({
      ...state,
      [id]: !state[id],
    }));
  }

  isOpen(id: string): boolean {
    return this.openSubmenus()[id];
  }
}
